/**
 * Activate a row's existing primary control without changing nested controls.
 * Keep a native button/link marked data-row-action for keyboard navigation.
 */
export function activateListRow(event:MouseEvent):void {
    if(event.defaultPrevented || event.button!==0 ||
       event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const row=event.currentTarget, target=event.target;
    if(!(row instanceof HTMLElement) || !(target instanceof Element)) return;
    if(target.closest('a,button,input,label,select,textarea,summary,[contenteditable],[role="button"],[role="checkbox"]')) return;
    if(window.getSelection()?.toString()) return;
    const action=row.querySelector<HTMLElement>('[data-row-action]');
    if(!action || action.matches(':disabled,[aria-disabled="true"]')) return;
    action.click();
}
